/* eslint-disable */
import Axios from "axios";

export const progress = {
  state: {},
  mutations: {},
  actions: {
    // PETICIONES A LA API
    async actionClickOnResource(context: any, payload: any) {

      await Axios
        .get(`${Axios.defaults.baseURL}progress/click/resource/${payload.resourceId}/activity/${payload.activityId}`)
        .then((res: any) => {
          console.log("Registrando progreso en recurso");
        })
        .catch((error: any) => {
          console.info(
            "Error al registrar progreso en recurso",
            payload,
            error
          );
        });
    },

  },
  getters: {},
};
